import { AssetStoryblok } from '@/lib/types/component-types-sb'
import Image from 'next/image'
import { ComponentProps } from 'react'

export function StoryblokImage({
  image,
  alt,
  cropWidth,
  cropHeight,
  ...props
}: Omit<ComponentProps<typeof Image>, 'src' | 'alt' | 'width' | 'height'> & {
  image: AssetStoryblok
  alt?: string
  cropWidth?: number
  cropHeight?: number
}) {
  let width = cropWidth || 1200
  let height = cropHeight || 0

  if (!cropWidth && !cropHeight) {
    // Extract dimensions from filename if crop dimensions not provided
    if (image.filename) {
      const match = image.filename.match(/\/(\d+)x(\d+)\//)
      if (match && match.length === 3) {
        width = parseInt(match[1], 10)
        height = parseInt(match[2], 10)
      }
    }
  }

  if (!image.filename || image.filename === '') {
    return (
      <div className="text-muted-foreground bg-muted border-border h-full w-full border p-4 text-center">
        Image could not be loaded
      </div>
    )
  }

  // Build the image URL with proper resizing and focal point
  let imageUrl = image.filename

  // Use crop dimensions when provided for proper focal point cropping
  if (cropWidth && cropHeight) {
    if (image.focus && image.focus !== '') {
      imageUrl += `/m/${cropWidth}x${cropHeight}/filters:focal(${image.focus})`
    } else {
      imageUrl += `/m/${cropWidth}x${cropHeight}`
    }
  } else {
    imageUrl += `/m/${width}x0`
  }

  return (
    <Image
      key={image.filename}
      {...props}
      src={imageUrl}
      alt={alt ?? image.alt ?? ''}
      width={width}
      height={height}
      unoptimized
    />
  )
}
